var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 522.05 396.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1{fill:#fff;}.cls-2{fill:#ffd600;}.cls-3{fill:#ff8900;}.cls-4{fill:#a4e280;}.cls-5{fill:#1639b7;}.cls-6{fill:#39c0da;}.cls-7{fill:#4e97ff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "456.05 264.02 390.04 330.03 390.04 264.02 456.05 264.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m456.05,136.13v127.9h-66.01V66.01l63.1,63.1c1.87,1.85,2.91,4.38,2.91,7.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m390.04,66.01v75.85c0-5.44-4.41-9.85-9.84-9.85h-163.82c-8.99,0-13.48-10.86-7.13-17.21l48.79-48.79h132.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 258.03,
    y: 132.01,
    width: 66,
    height: 66.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m324.03,198.02v66.01l-63.1,63.1c-1.79-1.79-2.91-4.27-2.91-7.01v-122.1h66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m390.04,264.03v66h-122.1c-2.73,0-5.21-1.11-7-2.9l63.1-63.1h66.01Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 71.05,
    y: 194.04,
    width: 24.5,
    height: 24.5,
    transform: "translate(-125.61 129.79) rotate(-47.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 140.01,
    y: 243.89,
    width: 32.2,
    height: 32.2,
    transform: "translate(-138.12 186.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 189.45,
    y: 172.93,
    width: 36.46,
    height: 36.46,
    transform: "translate(-74.35 202.84) rotate(-45)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f3c03237f4e2a8cf0de1c8bb9f395717.svg";
export { ForwardRef as ReactComponent };